import React from "react";

class CommonDisplayField extends React.Component {
  render() {
    return <div>{this.props.children}</div>;
  }
}

export default CommonDisplayField;
